import { render, staticRenderFns } from "./Neutral.vue?vue&type=template&id=18c2ffe5"
import script from "./Neutral.vue?vue&type=script&lang=js"
export * from "./Neutral.vue?vue&type=script&lang=js"
import style0 from "./Neutral.vue?vue&type=style&index=0&id=18c2ffe5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports